module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a37c0c0227061c4abe77f1dac93dd5b3.png";